/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import { useState, forwardRef } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { loginState, configState } from "../lib/State";
import log from "../lib/log";
import { Select, MenuItem } from "@mui/material";
import pr from "../lib/pr";

function GiftCenterSelect(props) {
  const { login, pHandleChange } = props;
  const [rows, setRows] = useState([]);
  const [data, setData] = useState({
    tcid:''
  });

  const handleChange = e => {
    setData(state => {
      let newState = state;
      newState[e.target.name] = e.target.value;
      return { ...newState };
    });
  }

  // const [tcid, setTcid] = useState('');
  // 가맹점 로드
  // 500 모든센터 (최고관리자)
  // 100 자기센터 (점장)
  // 50 자기센터 (직원)
  const load_data = async () => {
    let result = await axios.post(
      configState.api + "/gympass_admin/center_list"
    );
    let tmp_rows = result.data;
    if (login.level !== "500") {
      tmp_rows = tmp_rows.filter((el) => el.cid === login.cid);
    }
    setRows(tmp_rows);
  };

  useEffect(() => {
    if (login.level !== "") {
      load_data();
    }
  }, [login.level]);

  // 부모 컴퍼넌트 업데이트
  useEffect(() => {
    const e = {
      target: {
        name : 'tcid',
        value : data.tcid
      }
    }    
    pHandleChange(e);
  },[data.tcid]);

  return <FormControl sx={{ width: 260 }} size="small">
    <InputLabel>센터</InputLabel>
    <Select
      name="tcid"
      label="상태"
      onChange={handleChange}
      value={data.tcid}
    >
      {rows.map((item, index) => {
        return <MenuItem value={item.cid} key={index}>{item.center} :: {item.location}</MenuItem>
      })}
    </Select>
  </FormControl>

}

export default GiftCenterSelect;
